exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-form {\n    width: 100%;\n}\n.event-images-wrapper .v-avatar {\n    width: 65px!important;\n}\n.event-image-preview {\n    border-radius: 3px!important;\n}\n.event-attachment-desc {\n    padding-left: 15px;\n}\n.event-attachment-subtitle {\n    padding-left: 15px;\n}\n.empty-item-wrapper {\n    border: 2px dashed #CCC;\n    text-align: center;\n    padding: 10px;\n}\n.upload-image-wp {\n    cursor: pointer;\n}\n.hidden-textarea {\n    display: none;\n}\n.v-label.sp-v-label {\n    font-size: 0.9em;\n    color: #AAA;\n}\n.ql-snow .ql-tooltip {\n    z-index: 100;\n}\n", ""]);

// exports
